<ng-container *ngIf="size === 'large'">
  <div class="card large rounded-0 border-0">
    <a [routerLink]="[href]" class="link_overlay"></a>
    <div ngImagePixel #LargeImageHolder="imagePixel" class="thumbail-img">
      <img
        class="card-image-top img-fluid rounded-0"
        [alt]="classroom?.title"
        src="{{ getDefaultImage(classroom?.media) }}?{{
          LargeImageHolder.getImagePixel()
        }}&fit=crop"
        alt="Card image cap"
      />
    </div>
    <div class="card-body">
      <div class="instructor">
        sdfkj
      </div>
      <h5 class="card-title">{{ classroom?.title }}</h5>
      <p class="card-type text-capitalize">
        <ng-container *ngIf="!classroom.isWebinar; else showWebinar" >
          {{ classroom?.address?.city }},
          {{ classroom.regions[0].name | singleWord }}
        </ng-container>
         <ng-template #showWebinar>
           Webinar
         </ng-template>
      </p>
      <div class="card-rating" *ngIf="classroom?.rating > 0">
        <div class="rating">
          <ngx-show-rating color="#000000" [rate]="classroom?.rating" [max]="5"></ngx-show-rating>
        </div>
      </div>
      <div class="const">
        <!-- {{ priceCalculation(classroom)[0] }} -->
        <!-- <sup>{{ classroom?.price?.currency }} {{ classroom?.price?.pricePerGroup !== 0 ? 'Total' : 'Per person'}}</sup> -->
       <!--  <sup *ngIf="classroomIsFree(classroom) === false">{{
          classroom?.price?.currency
        }}</sup> -->
        500 <sup>NOK</sup>
      </div>
      <a class="card-details-btn" [routerLink]="[href]">
        <img alt="icon" class="arrow-icon" />
      </a>
    </div>
    <!-- <span class="badge badge-primary text-uppercase">{{classroom?.effort}}</span> -->
    <span class="badge badge-primary text-uppercase">KURS</span>
  </div>
</ng-container>

<ng-container *ngIf="size === 'medium'">
  <div class="card medium rounded-0 border-0">
    <a [routerLink]="[href]" class="link_overlay"></a>
    <div ngImagePixel #MediaumImageHolder="imagePixel" class="thumbail-img">
      <img
        class="card-image-top-mediaum img-fluid rounded-0"
        [alt]="classroom?.title"
        src="{{ getDefaultImage(classroom?.media) }}?{{
          MediaumImageHolder.getImagePixel()
        }}&fit=crop"
        alt="Card image cap"
      />
    </div>
    <div class="card-body">
      <h5 class="card-title">{{ classroom?.title }}</h5>
      <p class="card-type text-capitalize">
        <ng-container *ngIf="!classroom.isWebinar; else showWebinar" >
          {{ classroom?.address?.city }},
          {{ classroom.regions[0].name | singleWord }}
        </ng-container>
         <ng-template #showWebinar>
           Webinar
         </ng-template>
        </p>
      <div class="card-rating" *ngIf="classroom?.rating > 0">
        <div class="rating">
          <ngx-show-rating color="#000000" [rate]="classroom?.rating" [max]="5"></ngx-show-rating>
        </div>
      </div>
      <div class="const">
        <!-- {{ priceCalculation(classroom)[0] }} -->
        <!-- <sup>{{ classroom?.price?.currency }} {{ classroom?.price?.pricePerGroup !== 0 ? 'Total' : 'Per person'}}</sup> -->
       <!--  <sup *ngIf="classroomIsFree(classroom) === false">{{
          classroom?.price?.currency
        }}</sup> -->
        500 <sup>NOK</sup>
      </div>
      <a class="card-details-btn" [routerLink]="[href]">
        <img alt="icon" class="arrow-icon" />
      </a>
    </div>
    <!-- <span class="badge badge-primary text-uppercase">{{classroom?.effort}}</span> -->
    <span class="badge badge-primary text-uppercase">KURS</span>
  </div>
</ng-container>

<ng-container *ngIf="size === 'small'">
  <div class="card small rounded-0 border-0">
    <a [routerLink]="[href]" class="link_overlay"></a>
    <div class="thumbail-img">
      <img
        ngImagePixel
        #SmallImageHolder="imagePixel"
        class="card-img-top rounded-0 img-fluid"
        [alt]="classroom?.title"
        src="{{ getDefaultImage(classroom?.media) }}?{{
          SmallImageHolder.getImagePixel()
        }}&fit=crop"
        alt="Card image cap"
      />
    </div>
    <div class="card-body">
      <div class="instructor">
        <ng-container *ngIf="classroom.instructors[0]?.imageUrl else avatar">
          <div class="avatar" style="background-image: url({{baseCdnUrl + classroom.instructors[0].imageUrl+'?w=240'}})"></div>
        </ng-container>
        <ng-template #avatar>
          <div class="avatar" style="background-image: url('assets/images/user.png')"></div>
        </ng-template>
        <p class="name">{{ classroom.instructors[0].name }}</p>
      </div>

      <h5 class="card-title">{{ classroom?.title }}</h5>
      <p class="card-type text-capitalize">
        <ng-container *ngIf="!classroom.isWebinar; else showWebinar" >
          {{ classroom?.address?.city }},
          {{ classroom.regions[0].name }}
        </ng-container>
         <ng-template #showWebinar>
           Webinar
         </ng-template>
      </p>

      <div class="card-rating">
        <div class="rating" *ngIf="classroom?.rating > 0">
          <ngx-show-rating color="#000000" [rate]="classroom?.rating" [max]="5"></ngx-show-rating>
        </div>
      </div>
      <div class="const">
        <div class="d-flex flex-column flex-sm-column flex-md-column flex-lg-row justify-content-between">
          <div *ngIf="classroom.pricePerMember > 0" class="price-per-student">
            <span class="label">{{translationScope+'.rs_member' | transloco }}</span>
            {{ classroom.pricePerMember }}
            <sup>NOK</sup>
          </div>
          <div class="price-per-member">
            <span class="label">{{translationScope+'.rs_non_member' | transloco }}</span>
            {{ classroom.pricePerStudent }}
            <sup>NOK</sup>
          </div>
        </div>
      </div>
      <a class="card-details-btn" [routerLink]="[href]">
        <img alt="icon" class="arrow-icon" />
      </a>
    </div>
    <span class="badge badge-primary text-uppercase">{{ courseCategoryName }}</span>
  </div>
</ng-container>
